"use client";

import PropTypes from "prop-types";
import { Snackbar } from "@mui/material";
import { StyledAlert } from "./Toast.styles";

const Toast = ({
  open,
  onClose,
  severity,
  anchorOrigin = { vertical: "bottom", horizontal: "center" },
  autoHideDuration = 6000,
  children,
}) => {
  return (
    <Snackbar
      open={open}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      autoHideDuration={autoHideDuration}
    >
      <StyledAlert severity={severity}>{children}</StyledAlert>
    </Snackbar>
  );
};

Toast.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  severity: PropTypes.string,
  anchorOrigin: PropTypes.instanceOf(Object),
  autoHideDuration: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

export default Toast;
